// 此文件是通过脚本生成的，直接编辑无效！！！

// 不需要导航框架的页面路径
export const noFrames = [
    '/login',
];

// 不需要登录就可以访问的页面路径
export const noAuths = [
    '/login',
];

// 需要keep alive 页面
export const keepAlives = [
    {
        path: '/accounting/voucher/list',
        keepAlive: true,
    },
    {
        path: '/accounting/voucher/form/:type/:id',
        keepAlive: true,
    },
    {
        path: '/cashier/cash/list',
        keepAlive: true,
    },
    {
        path: '/statement/report/:type/:name/:icon',
        keepAlive: true,
    },
    {
        path: '/invoice/invoice/list',
        keepAlive: true,
    },
    {
        path: '/report/iframe/dynamic_report/:name/:icon',
        keepAlive: true,
    },
    {
        path: '/report/iframe/dynamic_single_report/:name/:icon',
        keepAlive: true,
    },
    {
        path: '/accounting/auxiliary/findAllList',
        keepAlive: true,
    },
    {
        path: '/ledger/account_balance/list',
        keepAlive: true,
    },
    {
        path: '/ledger/account_summary/list',
        keepAlive: true,
    },
    {
        path: '/ledger/account_balance_transaction/list/:id',
        keepAlive: true,
    },
    {
        path: '/ledger/general/list',
        keepAlive: true,
    },
    {
        path: '/ledger/sequential/list',
        keepAlive: true,
    },
];

// 页面路由配置
export default [
    {
        path: '/pdf/size/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/accounting/print_pdf_size/index.jsx'),
    },
    {
        path: '/accounting/voucher_template_type/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/accounting/voucher_template_type/index.jsx'),
    },
    {
        path: '/accounting/voucher_template/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/accounting/voucher_template/index.jsx'),
    },
    {
        path: '/accounting/voucher/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/accounting/voucher/index.jsx'),
    },
    {
        path: '/accounting/voucher/form/:type/:id',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/accounting/voucher/single_page/index.jsx'),
    },
    {
        path: '/cashier/accounting/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/cashier_manage/accounting/index.jsx'),
    },
    {
        path: '/cashier/cash/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/cashier_manage/cashier_cash/index.jsx'),
    },
    {
        path: '/cashier/income_type/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/cashier_manage/income_type/index.jsx'),
    },
    {
        path: '/cashier/internal/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/cashier_manage/internal/index.jsx'),
    },
    {
        path: '/cashier/ledger/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/cashier_manage/ledger/index.jsx'),
    },
    {
        path: '/cashier/statement',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/cashier_manage/statement/index.jsx'),
    },
    {
        path: '/statement/formulas/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/finance_report/formulas/index.jsx'),
    },
    {
        path: '/statement/report_default/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/finance_report/report_default/index.jsx'),
    },
    {
        path: '/statement/report/:type/:name/:icon',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/finance_report/report_template/index.jsx'),
    },
    {
        path: '/',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/home/index.jsx'),
    },
    {
        path: '/baiwang/invoice/invoiceIssue',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/invoice_manage/invoice_issue/index.jsx'),
    },
    {
        path: '/invoice/invoice/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/invoice_manage/invoice_manage/index.jsx'),
    },
    {
        path: '/invoice/template/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/invoice_manage/invoice_template/index.jsx'),
    },
    {
        path: '/report/iframe/dynamic_report/:name/:icon',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/jimu_report/report_iframe/dynamic_report.jsx'),
    },
    {
        path: '/report/iframe/dynamic_single_report/:name/:icon',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/jimu_report/report_iframe/dynamic_single_report.jsx'),
    },
    {
        path: '/accounting/auxiliary/findAllList',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/ledger_auxiliary/account_balance/index.jsx'),
    },
    {
        path: '/accounting/auxiliary/transaction/:id/:type',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/ledger_auxiliary/accounting_transaction/index.jsx'),
    },
    {
        path: '/ledger/account_balance/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/ledger/account_balance/index.jsx'),
    },
    {
        path: '/ledger/account_summary/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/ledger/account_summary/index.jsx'),
    },
    {
        path: '/ledger/account_balance_transaction/list/:id',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/ledger/calculate/index.jsx'),
    },
    {
        path: '/ledger/general/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/ledger/general/index.jsx'),
    },
    {
        path: '/ledger/sequential/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/ledger/sequential/index.jsx'),
    },
    {
        path: '/login',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/login/index.jsx'),
    },
    {
        path: '/checkout/carry_forward/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/settle_accounts/carry_forward/index.jsx'),
    },
    {
        path: '/checkout/checkout/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/settle_accounts/checkout/index.jsx'),
    },
    {
        path: '/system/access_log/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_manage/access_log/index.jsx'),
    },
    {
        path: '/asyn/task/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_manage/asyn_task/index.jsx'),
    },
    {
        path: '/system/authentication/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_manage/authentication/index.jsx'),
    },
    {
        path: '/system/dictionary/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_manage/dictionary/index.jsx'),
    },
    {
        path: '/system/permission/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_manage/menu_manage/index.jsx'),
    },
    {
        path: '/home/notice/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_manage/notice/index.jsx'),
    },
    {
        path: '/system/role/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_manage/role/index.jsx'),
    },
    {
        path: '/system/tenant/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_manage/tenant/index.jsx'),
    },
    {
        path: '/system/user/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_manage/user/index.jsx'),
    },
    {
        path: '/config/account_set/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/account_manage/account_set/index.jsx'),
    },
    {
        path: '/config/currency/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/account_manage/currency/index.jsx'),
    },
    {
        path: '/system/opening/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/account_manage/opening/index.jsx'),
    },
    {
        path: '/config/subject/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/account_manage/subject/index.jsx'),
    },
    {
        path: '/config/voucher_word/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/account_manage/voucher_word/index.jsx'),
    },
    {
        path: '/config/customer/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/adjust_accounts/customer/index.jsx'),
    },
    {
        path: '/config/department/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/adjust_accounts/department/index.jsx'),
    },
    {
        path: '/config/employee/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/adjust_accounts/employee/index.jsx'),
    },
    {
        path: '/config/organization/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/adjust_accounts/organization/index.jsx'),
    },
    {
        path: '/config/product/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/adjust_accounts/product/index.jsx'),
    },
    {
        path: '/config/project/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/adjust_accounts/project/index.jsx'),
    },
    {
        path: '/config/supplier/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/system_setting/adjust_accounts/supplier/index.jsx'),
    },
    {
        path: '/tax/proof/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/taxation_manage/tax_proof/index.jsx'),
    },
    {
        path: '/test1',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/test_page/test1/index.jsx'),
    },
    {
        path: '/wages/employees/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/wage_manage/employees/index.jsx'),
    },
    {
        path: '/wages/field/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/wage_manage/field/index.jsx'),
    },
    {
        path: '/wages/salaryDetail/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/wage_manage/salary_detail/index.jsx'),
    },
    {
        path: '/wages/socialSecurity/list',
        component: () => import('D:/Workspace/other/xingbing/xbfs-web/src/pages/wage_manage/social_security/index.jsx'),
    },
];
